export const API_METHOD_GET_SUJETS = 'API/METHOD/GET_SUJETS'
export const API_METHOD_POST_UPLOAD = 'API/METHOD/POST_UPLOAD'
export const LANG_DE = 'de'
export const LANG_EN = 'en'
export const MAX_STEPS = 3

export const FETCH_STATUS_PENDING = 'FETCH/LOADING'
export const FETCH_STATUS_ERROR = 'FETCH/ERROR'
export const FETCH_STATUS_IDLE = 'FETCH/IDLE'

export const ROUTE_SELECT = '/select'
export const ROUTE_UPLOAD = '/upload'
export const ROUTE_SHOWMOCK = '/showmock'

export const ERROR_FILE_SIZE = 'ERROR/FILE/SIZE'
export const ERROR_FILE_FORMAT_WRONGMIME = 'ERROR/FILE/FORMAT_WRONGMIME'
export const ERROR_FILE_FORMAT_NOIMAGE = 'ERROR/FILE/FORMAT_NOIMAGE'
export const ERROR_FILE_FORMAT_INVALIDIMAGE = 'ERROR/FILE/FORMAT_INVALIDIMAGE'

export const WARNING_FILE_ASPECT_RATIO = 'WARNING/FILE/ASPECT_RATIO'
